export default __webpack_public_path__ + "static/media/african1.af2d9806.jpg";